import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { API_LOCALIZATIONS } from '../../../consts'
import { to } from '../../../utils/to'

export interface CreateLocalizationPayload {
  catalog_product_id: string
  country: string
  subdivision: string
  name?: string
  description?: string
  category_label?: string
  lineage?: string
  images?: string[] | null
  image_urls?: string[] | null
}

export interface CreateLocalizationResponse {
  productLocalizationId: string
}

export const createLocalization = async (payload: CreateLocalizationPayload) => {
  const request: AxiosRequestConfig = {
    url: API_LOCALIZATIONS,
    method: 'POST',
    data: payload,
    headers: { 'content-type': 'application/json' },
    withCredentials: true,
  }

  return to<AxiosResponse<CreateLocalizationResponse>, AxiosError>(axios(request))
}
